import { Alert as ChakraAlert, ButtonGroup } from '@chakra-ui/react';

import { AlertProps } from './alert.props';

export const Alert = ({
    status = 'info',
    title,
    children,
    customIcon,
    buttons = [],
    titleProps = {},
    dangerouslySetInnerHTML,
    hideIcon = false,
    ...rest
}: AlertProps): JSX.Element => {
    return (
        <ChakraAlert.Root
            status={status}
            bgColor={status === 'error' ? 'red.50' : undefined}
            {...rest}
        >
            {!hideIcon ? <ChakraAlert.Indicator /> : null}

            <ChakraAlert.Content>
                {title ? (
                    <ChakraAlert.Title mb={'2'} {...titleProps}>
                        {title}
                    </ChakraAlert.Title>
                ) : null}
                <ChakraAlert.Description
                    dangerouslySetInnerHTML={dangerouslySetInnerHTML ?? undefined}
                    children={!dangerouslySetInnerHTML ? children : undefined}
                />
                {buttons && buttons.length ? (
                    <ButtonGroup mt={4} gap={4} justifyContent={'end'} display={'flex'}>
                        {buttons.map(button => button)}
                    </ButtonGroup>
                ) : null}
            </ChakraAlert.Content>
        </ChakraAlert.Root>
    );
};
